import {styled, Box} from '@mui/material';

export const AppointmentsListContainer = styled(Box)`
	padding: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

export const StyledBox = styled(Box)`
	margin-top: auto;
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 56px;
	}
`;
